export const GetNcrOrderDetails = "bda889bd8b54c6b01e68cb7a51dbd8dad228d2998bccf3fda07e842577bec853";